/**
 * Zod validation schemas for Install Flow forms
 *
 * This file contains all form validation schemas used across the installation
 * wizard. Schemas are shared to ensure consistency between form validation
 * and TypeScript types.
 */

import * as z from 'zod'

/**
 * Location form validation schema
 * Validates location creation form with address fields
 */
export const locationFormSchema = z.object({
  name: z.string().min(1, 'Location name is required'),
  address_line_1: z.string().min(1, 'Address is required'),
  address_line_2: z.string().optional(),
  city: z.string().min(1, 'City is required'),
  state: z.string().min(2, 'State is required'),
  postal_code: z.string().min(1, 'Postal code is required'),
  country: z.string().default('USA'),
})

/**
 * Sublocation form validation schema
 * Validates sublocation creation form
 */
export const sublocationFormSchema = z.object({
  name: z.string().min(1, 'Sublocation name is required'),
})

/**
 * Unit name form validation schema
 * Validates unit name input (simplified installation step)
 */
export const equipmentNameFormSchema = z.object({
  name: z.string().min(1, 'Unit name is required'),
})

/**
 * Installation form validation schema
 * Validates equipment installation form with manufacturer, model, and serial number
 */
export const installationFormSchema = z.object({
  name: z.string(),
  manufacturer_id: z.number().nullable(),
  manufacturer_name: z.string(),
  model_id: z.number().nullable(),
  model_name: z.string(),
  serial_number: z.string().optional(),
}).refine((data) => data.model_id !== null || data.model_name.length > 0, {
  message: 'Equipment model is required',
  path: ['model_id'],
})

/**
 * Sensor kit form validation schema
 * Validates sensor kit serial number for linking to installation
 */
export const sensorKitFormSchema = z.object({
  sensor_kit_serial_number: z.string().min(1, 'Sensor kit serial number is required'),
})